/* eslint-disable import/prefer-default-export */

import { makeEntityScaffold } from '@classpass/saga-tools';

export const contentTags = makeEntityScaffold(
  'SAGA.API.GET_CONTENT_TAGS',
  (client, type, ids) => client.tags.contentTags({ content_type: type, content_ids: ids }).then(data => data.content),
  { defaultKey: (client, type, ids) => `${type}_${ids.join('_')}` }
);

export const contentTagsV2 = makeEntityScaffold(
  'SAGA.API.GET_CONTENT_TAGS_V2',
  (client, type, ids) => client.tags.contentTagsV2({ content_type: type, content_ids: ids }).then(data => data.content),
  { defaultKey: (client, type, ids) => `${type}_${ids.join('_')}` }
);

export const taggedContent = makeEntityScaffold(
  'SAGA.API.GET_TAGGED_CONTENT',
  (client, type, tags) => client.tags.taggedContent({ content_type: type, tags }).then(data => data.content_ids),
  { defaultKey: (client, type, tags) => `${type}_${tags.join('_')}` }
);

export const tagList = makeEntityScaffold(
  'SAGA.API.GET_TAGS',
  (client, options) => client.tags.getV3(options).then(data => data.tags),
  { defaultKey: 1 }
);
